import { useDAL } from '@/contexts/useDAL';

export const useManagementGroups = () => {
  const dal = useDAL();
  const {
    data: managementGroupsBody,
    isLoading,
    mutate,
  } = dal.cloudAccounts.managementGroups.useList();
  const managementGroups = managementGroupsBody?.managementGroups || [];

  return { managementGroups, isLoading, mutate };
};
